// extracted by mini-css-extract-plugin
export default {"icon16":"V_ciM","icon17":"aY1Kl","icon18":"wWdQO","icon21":"HBM02","icon22":"ElY0D","icon24":"XRDsH","icon32":"Ccgys","icon42":"C6_uB"};